<template>
	<div class="container">
		<div class="row" v-if="!$root.isMobile()">
			<div class="col-lg-5 col-6 logo-bg d-flex align-items-center">
				<img src="@/assets/images/logo-pagbrasil.svg" alt="PagBrasil" class="img-responsive" />
			</div>

			<div class="col-lg-7 col-6 bg-primary">
				<span class="header-title">Dados da Conta</span>
				<small class="text-white float-right" v-if="firstName">Olá, {{ firstName }}</small>
			</div>
		</div>

		<div class="row" v-if="$root.isMobile()">
			<div class="col-lg-12 d-flex align-items-center">
				<img
					src="@/assets/images/icons/back-white.svg"
					class="back-header"
					alt="Back"
					v-if="$store.state.form.step > 0"
					@click="returnToPreviousStep" />
				<img src="@/assets/images/simbolo-pb.svg" alt="PagBrasil" />

				<span class="header-title">{{ title }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "HeaderComponent",
	props: ["title"],
	computed: {
		firstName() {
			if (!this.$store.state.form.personal.fullname) {
				return "";
			}

			return this.$store.state.form.personal.fullname.split(" ")[0];
		},
	},
	methods: {
		returnToPreviousStep(e) {
			const $store = this.$store;
			const currentStep = $store.state.form.step;

			currentStep > 0 && $store.commit("setStep", currentStep - 1);

			this.$nextTick(() => {
				this.$parent.validationTrigger = !this.$parent.validationTrigger;
			});
		},
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors";
@import "@/assets/scss/styles";

.container {
	max-width: 100%;
}

.row div {
	margin: 0;
	padding: 18px 0;
}

.row .col-lg-5 {
	padding-left: $grid-padding !important;
}

.row .col-lg-7 {
	padding-right: $grid-padding !important;
}

@media only screen and (max-width: 1600px) {
	$grid-padding: 10%;

	.row .col-lg-5 {
		padding-left: $grid-padding !important;
	}

	.row .col-lg-7 {
		padding-right: $grid-padding !important;
	}
}

.row .col-lg-12 {
	background-color: #03102f;
	color: #fff;
	padding: 15px 25px;

	.header-title {
		color: #fff;
		font-size: 18px;
		margin-left: 10px;
		font-family: "Montserrat", sans-serif;
	}
}

.header-title {
	color: #fff;
	font-size: 22px;
	margin-left: 70px;
	font-family: "Montserrat", sans-serif;
}

small {
	font-weight: 100;
	margin-top: 6px;
	font-family: "Nunito Sans", sans-serif;
	font-size: 14px;
	margin-right: 20px;
}

.back-header {
	height: 17px;
	width: auto;
	padding: 0 15px 0 0;
	cursor: pointer;
}
</style>
